import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Planning/imprimirVerracosPlanificados`, method: 'GET', body: null, token: token})
}